import { Component, OnInit, TemplateRef, Inject, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import Moralis from 'moralis';
import { User } from '../lib/entities/User';
import { Store } from '@ngrx/store';
import { MarketState } from '../lib/+state/market.reducer';
import { Observable, Subject } from 'rxjs';
import { takeUntil} from 'rxjs/operators';
import { threadId } from 'worker_threads';
import { AuthService } from '../lib/services/auth.service';
import { environment } from 'src/environments/environment.prod';
import { ActivatedRoute, Router } from '@angular/router';
import { MainFacade } from '../pages/main.facade';
var moment = require('moment-timezone');
//import { MarketComponent } from '../pages/market/market.component';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})

export class NavComponent implements OnInit, OnDestroy {
  public login$: Observable<any>|undefined;
  public error$: Observable<any>|undefined;
  public user$: Observable<any>|undefined;
  public nfts$: Observable<any>|undefined;
  public eth$: Observable<any>|undefined;
  private destroy$ = new Subject();
  profileDropDown:boolean = false;
  showMobileMenu: boolean = false;
  walletSplit: any;
  wallet: any;
  walletFull: any;
  user:any;
  urlmanual:any='';
  showNftsAvatar:boolean = false;
  constructor(@Inject(DOCUMENT) private doc: Document, private store: Store<MarketState>, private auth:AuthService, private mainfacade:MainFacade, private router:Router) {
    

  }

  ngOnInit(): void {
    this.setObservables();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  setObservables() {
    this.login$ = this.mainfacade.login$;
    this.error$ = this.mainfacade.error$;
    this.nfts$ = this.mainfacade.nfts$
    this.user$ = this.mainfacade.user$;
    this.eth$ = this.mainfacade.eth$;
    this.user$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 

      if(message){
        this.user = message;
        this.wallet = this.user.Wallet.slice(0, 4) + "..." + this.user.Wallet.slice(41, 44);
 

        //this.burnWallet =  this.user.Wallets[0];
      }

    });

    this.login$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        this.walletFull = message
        this.walletSplit = message.slice(0, 4) + "..." + message.slice(41, 44);
      }

    });

    this.login();

  }

  login(){
    this.mainfacade.login(null);
  }


  logout() {
    this.mainfacade.logout();
    
  }

  clearModals(){
    this.showMobileMenu =false;
  
  }

  controlModal(loc:string){
    this.clearModals();
    
    
  }

  /*showProfileDP() {
    this.newUsername = this.user?.UserName;

    this.profileDropDown = !this.profileDropDown;
  }*/

  closePop(){
    //this.mainfacade.getPopup('');
  }

  openMenu(){
    this.mainfacade.getMobileMenu(true);
  }

}
